<script lang="ts">
  import { createMenu } from 'svelte-headlessui';
  import { Transition } from 'svelte-transition';
  import TablerDotsVertical from '~icons/tabler/dots-vertical';
  import TablerFilter from '~icons/tabler/filter';
  import TablerSettings from '~icons/tabler/settings';
  import { openPreferencesTab } from './preferences/PreferencesTabs.svelte';
  import { isFiltering } from '$utils/filters';

  const menu = createMenu({ label: 'Overflow' });

  function showPreferences() {
    openPreferencesTab('Site Config');
  }

  function toggleRaceFilters() {
    isFiltering.update((v) => !v);
  }

  const items = [
    { text: 'Preferences', action: showPreferences, icon: TablerSettings },
    {
      text: `Toggle Race Filters`,
      action: toggleRaceFilters,
      icon: TablerFilter
    }
  ];
</script>

<div class="relative">
  <div
    use:menu.button
    class="relative mr-2 flex h-full cursor-pointer items-center justify-center rounded-lg hover:bg-gray-100"
  >
    <TablerDotsVertical class="w-8" />
  </div>

  <Transition
    show={$menu.expanded}
    enter="transition ease-out duration-100"
    enterFrom="transform opacity-0 scale-95"
    enterTo="transform opacity-100 scale-100"
    leave="transition ease-in duration-75"
    leaveFrom="transform opacity-100 scale-100"
    leaveTo="transform opacity-0 scale-95"
  >
    <div
      use:menu.items
      class="absolute right-0 top-0 z-40 mt-10 w-44 divide-y divide-gray-100 rounded-md bg-white p-2 text-sm shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
    >
      {#each items as item}
        {@const active = $menu.active === item.text}
        <button
          on:click={item.action}
          use:menu.item
          class="group flex w-full items-center rounded-md px-2 py-2 text-sm {active
            ? 'bg-gray-100 text-gray-900'
            : 'text-gray-900'}"
        >
          <svelte:component
            this={item.icon}
            class="mr-2 h-5 w-5 text-gray-700"
          />
          {item.text}
        </button>
      {/each}
    </div>
  </Transition>
</div>
